import SessionContactInfoModel from './models/contact-info.js';

export default class SessionContactInfo {
	constructor () {
		this.bindEvents();
	}

	bindEvents () {
		document.addEventListener('fib_chat:has_user_info', (e) => {
			const info = e.detail;

			if (info.FirstName && info.LastName && info.Email) {
				this.saveContactInfo(info);
			}
		});
	}

	saveContactInfo (contactInfo) {
		const infoModel = new SessionContactInfoModel(contactInfo);

		infoModel
			.save()
			.then(() => {
				const e = new CustomEvent('[Session]:has_user_info', { detail: contactInfo });

				document.dispatchEvent(e);
			});
	}
}